module.exports = __webpack_public_path__ + "static/woodenstacker-9279e4bd1e077209ab19ac755ac30776.jpeg";